export function normalizeLinkedObject(object) {
	const id = object.id ?? object.objectId
	if (object.availability === 'UNAVAILABLE') {
		return {
			id,
			objectId: object.objectId ?? id,
			requestObjectId: object.requestObjectId ?? object.request_object_id,
			status: object.status ?? object.request_object_status,
			availability: 'UNAVAILABLE',
		}
	}
	return { ...object, id }
}
